export default [{
  path: '/auth/signin',
  name: 'auth-signin',
  component: () => import(/* webpackChunkName: "auth-signin" */ '@/pages/auth/SigninPage.vue'),
  meta: {
    layout: 'auth'
  }
}, {
  path: '/auth/signup',
  name: 'auth-signup',
  component: () => import(/* webpackChunkName: "auth-signup" */ '@/pages/auth/SignupPage.vue'),
  meta: {
    layout: 'auth'
  }
}, {
  path: '/auth/verify-email',
  name: 'auth-verify-email',
  component: () => import(/* webpackChunkName: "auth-verify-email" */ '@/pages/auth/VerifyEmailPage.vue'),
  meta: {
    layout: 'auth'
  }
}, {
  path: '/auth/forgot-password',
  name: 'auth-forgot',
  component: () => import(/* webpackChunkName: "auth-forgot" */ '@/pages/auth/ForgotPage.vue'),
  meta: {
    layout: 'auth'
  }
}, {
  path: '/auth/reset-password',
  name: 'auth-reset',
  component: () => import(/* webpackChunkName: "auth-reset" */ '@/pages/auth/ResetPage.vue'),
  meta: {
    layout: 'auth'
  }
}, {
  path: '/error/not-found',
  name: 'error-not-found',
  component: () => import(/* webpackChunkName: "error-not-found" */ '@/pages/error/NotFoundPage.vue'),
  meta: {
    layout: 'error'
  }
}, {
  path: '/error/unexpected',
  name: 'error-unexpected',
  component: () => import(/* webpackChunkName: "error-unexpected" */ '@/pages/error/UnexpectedPage.vue'),
  meta: {
    layout: 'error'
  }
}, {
  path: '/utility/maintenance',
  name: 'utility-maintenance',
  component: () => import(/* webpackChunkName: "utility-maintenance" */ '@/pages/utility/MaintenancePage.vue'),
  meta: {
    layout: 'auth'
  }
}, {
  path: '/utility/coming-soon',
  name: 'utility-soon',
  component: () => import(/* webpackChunkName: "utility-soon" */ '@/pages/utility/SoonPage.vue'),
  meta: {
    layout: 'auth'
  }
}, {
  path: '/utility/help',
  name: 'utility-help',
  component: () => import(/* webpackChunkName: "utility-help" */ '@/pages/utility/HelpPage.vue')
},

{
  path: '/view2fa',
  name: 'view2fa',
  component: () => import(/* webpackChunkName: "all-tickets" */ '@/pages/auth/view2fa.vue'),
  meta: {
    layout: 'auth'
  }
},
{
  path: '/setting2fa',
  name: 'setting2fa',
  component: () => import(/* webpackChunkName: "all-tickets" */ '@/pages/auth/setting2fa.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/coupons',
  name: 'coupons',
  component: () => import(/* webpackChunkName: "all-tickets" */ '@/pages/coupons/Coupons.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/dashboardClient_search',
  name: 'dashboardClient_search',
  component: () => import(/* webpackChunkName: "all-tickets" */ '@/pages/dashBoardClient/search.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/dashboardClient_get',
  name: 'dashboardClient',
  component: () => import(/* webpackChunkName: "all-tickets" */ '@/pages/dashBoardClient/index.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/resumen-cliente',
  name: 'resumen-cliente',
  component: () => import(/* webpackChunkName: "resumen-cliente" */ '@/pages/resumenCliente/ResumenClientePage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/correos',
  name: 'correos-bitacora',
  component: () => import(/* webpackChunkName: "email-log" */ '@/pages/emailLog/AllEmailsPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/planes-servicios',
  name: 'planes-servicios',
  component: () => import(/* webpackChunkName: "planes-servicios" */ '@/pages/planes/PlanesIndex.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/planes-servicios/crear',
  name: 'planes-servicios-crear',
  component: () => import(/* webpackChunkName: "planes-servicios" */ '@/pages/planes/PlanesForm.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/planes-servicios/:id/editar',
  name: 'planes-servicios-editar',
  component: () => import(/* webpackChunkName: "planes-servicios" */ '@/pages/planes/PlanesForm.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/acceso-ip-internacional-temporal',
  name: 'acceso-ip-internacional-temporal',
  component: () => import(/* webpackChunkName: "acceso-ip-internacional-temporal" */ '@/pages/acceso-ip-internacional-temporal/AccesoIpInternacionalTemporalPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/smtp-temporal',
  name: 'smtp-temporal',
  component: () => import(/* webpackChunkName: "smtp-temporal" */ '@/pages/smtp-temporal/SmtpTemporalPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/smtp-poolname',
  name: 'smtp-poolname',
  component: () => import(/* webpackChunkName: "smtp-poolname" */ '@/pages/smtp-poolname/SmtpPoolnamePage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/redes/gestion-politicas',
  name: 'redes-gestion-politicas',
  component: () => import(/* webpackChunkName: "redes-gestion-politicas" */ '@/pages/redes/gestion-politicas/GestionPoliticasPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/datacenter/visitas',
  name: 'visitas-datacenter',
  component: () => import(/* webpackChunkName: "visitas-datacenter" */ '@/apps/visitas_datacenter/pages/VisitasDatacenterPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/datacenter/aire-acondicionado',
  name: 'aire-acondicionado',
  component: () => import(/* webpackChunkName: "aire-acondicionado" */ '@/apps/aire_acondicionado/pages/AireAcondicionadoPage.vue'),
  meta: { requiresAuth: true }
},

{
  // Pantalla de captura de la ronda: se usa dentro del datacenter, muchas
  // veces desde un móvil, por eso va aparte del listado.
  path: '/datacenter/aire-acondicionado/ronda/:id',
  name: 'aire-acondicionado-ronda',
  component: () => import(/* webpackChunkName: "aire-acondicionado-ronda" */ '@/apps/aire_acondicionado/pages/RondaAirePage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/mantenedor/aire-acondicionado',
  name: 'mantenedor-aire-acondicionado',
  component: () => import(/* webpackChunkName: "mantenedor-aire-acondicionado" */ '@/pages/mantenedor/aire-acondicionado/AireAcondicionadoMantenedorPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/mantenedor/datacenters',
  name: 'mantenedor-datacenters',
  component: () => import(/* webpackChunkName: "mantenedor-datacenters" */ '@/pages/mantenedor/datacenters/DatacentersPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/mantenedor/departamentos',
  name: 'mantenedor-departamentos',
  component: () => import(/* webpackChunkName: "mantenedor-departamentos" */ '@/pages/mantenedor/departamentos/DepartamentosPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/mantenedor/textos-ticket',
  name: 'mantenedor-textos-ticket',
  component: () => import(/* webpackChunkName: "mantenedor-textos-ticket" */ '@/pages/mantenedor/textos-ticket/TextosTicketPage.vue'),
  meta: { requiresAuth: true }
},

{
  path: '/api-tokens',
  name: 'api-tokens',
  component: () => import(/* webpackChunkName: "api-tokens" */ '@/pages/api-tokens/ApiTokensPage.vue'),
  meta: { requiresAuth: true }
},

// ── Proveedores internacionales ─────────────────────────────────────
{
  path: '/proveedores-internacionales',
  redirect: '/proveedores-internacionales/panel'
},
{
  path: '/proveedores-internacionales/panel',
  name: 'proveedores-internacionales',
  component: () => import(/* webpackChunkName: "proveedores-internacionales" */ '@/pages/proveedores-internacionales/ProveedoresInternacionalesDashboard.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/proveedores-internacionales/listado',
  name: 'proveedores-internacionales-listado',
  component: () => import(/* webpackChunkName: "proveedores-internacionales" */ '@/pages/proveedores-internacionales/ProveedoresInternacionalesPage.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/proveedores-internacionales/crear',
  name: 'proveedores-internacionales-crear',
  component: () => import(/* webpackChunkName: "proveedores-internacionales" */ '@/pages/proveedores-internacionales/ProveedoresInternacionalesForm.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/proveedores-internacionales/tareas',
  name: 'proveedores-internacionales-tareas',
  component: () => import(/* webpackChunkName: "proveedores-internacionales" */ '@/pages/proveedores-internacionales/TareasProveedoresPage.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/proveedores-internacionales/:id/editar',
  name: 'proveedores-internacionales-editar',
  component: () => import(/* webpackChunkName: "proveedores-internacionales" */ '@/pages/proveedores-internacionales/ProveedoresInternacionalesForm.vue'),
  meta: { requiresAuth: true }
},
{
  path: '/proveedores-internacionales/:id',
  name: 'proveedores-internacionales-detalle',
  component: () => import(/* webpackChunkName: "proveedores-internacionales" */ '@/pages/proveedores-internacionales/ProveedorDetalle.vue'),
  meta: { requiresAuth: true }
},

]
